import React from 'react';
import { Section } from './ui/Section';
import { Phone, Instagram, Facebook, MessageCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <Section className="bg-brand-dark relative border-t border-white/5" data-id="element-79">
      {/* Glow effect */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-64 bg-brand-accent/10 blur-[100px] pointer-events-none" data-id="element-80"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-81">
        <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-82">
          El Siguiente Paso Es Simple
        </h2>

        <div className="text-xl text-slate-300 space-y-4 mb-12" data-id="element-83">
          <p data-id="element-84">No hay formularios complicados. No hay procesos largos.</p>
          <p className="text-white font-semibold" data-id="element-85">
            Escríbeme directamente por WhatsApp ahora mismo.
          </p>
          <p data-id="element-86">
            Cuéntame brevemente sobre tu negocio y lo que necesitas. Hablamos,
            analizamos tu situación y te digo exactamente cómo puedo ayudarte.
          </p>
          <p className="text-brand-accent" data-id="element-87">
            Sin presión. Sin compromiso. Solo una conversación estratégica que
            puede cambiarlo todo.
          </p>
        </div>

        <div className="bg-brand-surface/50 border border-white/10 p-8 md:p-12 rounded-3xl mb-16" data-id="element-88">
          <p className="text-sm font-bold text-slate-400 uppercase tracking-widest mb-6" data-id="element-89">
            👇 HAZ CLIC AQUÍ Y ESCRÍBEME POR WHATSAPP AHORA
          </p>

          <Button href="https://wa.me/56972115173?text=Hola%20Nacho%2C%20quiero%20mi%20web%20profesional" target="_blank" size="lg" className="w-full sm:w-auto text-lg px-12 py-6 mb-8" icon={<MessageCircle className="w-6 h-6" data-id="element-91" />} data-id="element-90">
            QUIERO MI WEB PROFESIONAL →
          </Button>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-slate-300" data-id="element-92">
            <a href="https://wa.me/56972115173" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-accent transition-colors" data-id="element-93">
              <Phone className="w-5 h-5" data-id="element-94" />
              <span data-id="element-95">+56 9 7211 5173</span>
            </a>
            <a href="https://www.instagram.com/nachogomezmkt/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-accent transition-colors" data-id="element-96">
              <Instagram className="w-5 h-5" data-id="element-97" />
              <span data-id="element-98">@nachogomezmkt</span>
            </a>
            <a href="https://web.facebook.com/nachogomezmkt/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-accent transition-colors" data-id="element-99">
              <Facebook className="w-5 h-5" data-id="element-100" />
              <span data-id="element-101">Nacho Gomez Mkt</span>
            </a>
          </div>
        </div>

        <blockquote className="text-2xl md:text-3xl font-medium text-white italic max-w-3xl mx-auto leading-relaxed" data-id="element-102">
          "La mejor inversión que puedes hacer en tu negocio es ser visto como
          lo que realmente eres."
          <footer className="text-lg text-brand-accent mt-6 font-bold not-italic" data-id="element-103">
            — Nacho Gomez
          </footer>
        </blockquote>
      </div>
    </Section>;
}